<template>
  <div>
    <h3>Environment</h3>
    <p v-if="environment" class="env">{{ environment }}</p>
    <p v-if="showUserAgent" class="env">{{ userAgent }}</p>
    <button
      v-else
      class="btn btn-primary btn-sm"
      @click="() => (showUserAgent = true)"
    >
      Show User Agent
    </button>
  </div>
</template>
<script>
import environment from "@/util/environment";

export default {
  data: function () {
    return {
      environment: "",
      showUserAgent: false,
    };
  },
  computed: {
    userAgent: function () {
      return window.navigator.userAgent;
    },
  },
  created: function () {
    this.environment = environment.get();
  },
};
</script>
<style lang="scss" scoped>
h5 {
  font-weight: bold;
}

.env {
  font-size: 0.8rem;
}
</style>
